import {
  DRIVER_PARTNER_ANALYTICS_SUMMARY_REQUEST,
  DRIVER_PARTNER_ANALYTICS_SUMMARY_SUCCESS,
  DRIVER_PARTNER_ANALYTICS_SUMMARY_FAIL,

  DRIVER_PARTNER_PARTNER_PERFORMANCE_REQUEST,
  DRIVER_PARTNER_PARTNER_PERFORMANCE_SUCCESS,
  DRIVER_PARTNER_PARTNER_PERFORMANCE_FAIL,

  DRIVER_PARTNER_COMMISSION_LIABILITY_REQUEST,
  DRIVER_PARTNER_COMMISSION_LIABILITY_SUCCESS,
  DRIVER_PARTNER_COMMISSION_LIABILITY_FAIL,

  DRIVER_PARTNER_PAID_COMMISSIONS_REQUEST,
  DRIVER_PARTNER_PAID_COMMISSIONS_SUCCESS,
  DRIVER_PARTNER_PAID_COMMISSIONS_FAIL,

  DRIVER_PARTNER_SUSPICIOUS_REFERRALS_REQUEST,
  DRIVER_PARTNER_SUSPICIOUS_REFERRALS_SUCCESS,
  DRIVER_PARTNER_SUSPICIOUS_REFERRALS_FAIL,

  DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_REQUEST,
  DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_SUCCESS,
  DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_FAIL,

  DRIVER_PARTNER_TOP_PERFORMING_REQUEST,
  DRIVER_PARTNER_TOP_PERFORMING_SUCCESS,
  DRIVER_PARTNER_TOP_PERFORMING_FAIL,
} from "./types";

import {
  fetchDriverPartnerAnalyticsSummary,
  fetchPartnerPerformance,
  fetchCommissionLiability,
  fetchPaidCommissions,
  fetchSuspiciousReferrals,
  fetchReferredDriverLocations,
  fetchTopPerformingPartners,
} from "../../services/driverPartnerAnalyticsService";

export const getDriverPartnerAnalyticsSummary =
  () => async (dispatch) => {
    dispatch({
      type: DRIVER_PARTNER_ANALYTICS_SUMMARY_REQUEST,
    });

    const response =
      await fetchDriverPartnerAnalyticsSummary();

    if (response.success) {
      dispatch({
        type: DRIVER_PARTNER_ANALYTICS_SUMMARY_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: DRIVER_PARTNER_ANALYTICS_SUMMARY_FAIL,
        payload: response.message,
      });
    }
  };

export const getPartnerPerformance =
  () => async (dispatch) => {
    dispatch({
      type: DRIVER_PARTNER_PARTNER_PERFORMANCE_REQUEST,
    });

    const response =
      await fetchPartnerPerformance();

    if (response.success) {
      dispatch({
        type: DRIVER_PARTNER_PARTNER_PERFORMANCE_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: DRIVER_PARTNER_PARTNER_PERFORMANCE_FAIL,
        payload: response.message,
      });
    }
  };

export const getCommissionLiability =
  () => async (dispatch) => {
    dispatch({
      type: DRIVER_PARTNER_COMMISSION_LIABILITY_REQUEST,
    });

    const response =
      await fetchCommissionLiability();

    if (response.success) {
      dispatch({
        type: DRIVER_PARTNER_COMMISSION_LIABILITY_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: DRIVER_PARTNER_COMMISSION_LIABILITY_FAIL,
        payload: response.message,
      });
    }
  };

export const getPaidCommissions =
  () => async (dispatch) => {
    dispatch({
      type: DRIVER_PARTNER_PAID_COMMISSIONS_REQUEST,
    });

    const response =
      await fetchPaidCommissions();

    if (response.success) {
      dispatch({
        type: DRIVER_PARTNER_PAID_COMMISSIONS_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: DRIVER_PARTNER_PAID_COMMISSIONS_FAIL,
        payload: response.message,
      });
    }
  };

export const getSuspiciousReferrals =
  () => async (dispatch) => {
    dispatch({
      type: DRIVER_PARTNER_SUSPICIOUS_REFERRALS_REQUEST,
    });

    const response =
      await fetchSuspiciousReferrals();

    if (response.success) {
      dispatch({
        type: DRIVER_PARTNER_SUSPICIOUS_REFERRALS_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: DRIVER_PARTNER_SUSPICIOUS_REFERRALS_FAIL,
        payload: response.message,
      });
    }
  };

export const getReferredDriverLocations =
  () => async (dispatch) => {
    dispatch({
      type: DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_REQUEST,
    });

    const response =
      await fetchReferredDriverLocations();

    if (response.success) {
      dispatch({
        type: DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_FAIL,
        payload: response.message,
      });
    }
  };

export const getTopPerformingPartners =
  (limit = 10) => async (dispatch) => {
    dispatch({
      type: DRIVER_PARTNER_TOP_PERFORMING_REQUEST,
    });

    const response =
      await fetchTopPerformingPartners(limit);

    if (response.success) {
      dispatch({
        type: DRIVER_PARTNER_TOP_PERFORMING_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: DRIVER_PARTNER_TOP_PERFORMING_FAIL,
        payload: response.message,
      });
    }
  };